import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  VIEW_START,
  VIEW_SUCCESS,
  VIEW_FAILURE,
  SAVE_START,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  CATS_LOADED,
  USERS_LOADED,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_FAILURE
} from './actions.js';

const initialState = {
  loading: false,
  saving: false,
  errors: null,
  nonprofit: null,
  nonprofits: [],
  categories: [],
  users: []
};

export default (state = {}, action) => {
  const newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case VIEW_START:
      newState.loading = true;
      newState.errors = null;
      newState.nonprofit = null;
      break;
    case VIEW_FAILURE:
      newState.loading = true;
      newState.errors = action.payload;
      newState.nonprofit = null;
      break;
    case VIEW_SUCCESS:
      newState.loading = false;
      newState.errors = null;
      newState.nonprofit = action.payload.data;
      break;
    case LOAD_START:
      newState.loading = true;
      newState.nonprofits = [];
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.nonprofits = action.payload;
      break;
    case SAVE_START:
      newState.saving = true;
      newState.nonprofit.asks = newState.nonprofit.asks.map(a => {
        if (a.id === action.payload) {
          a.saving = true;
        }
        return a;
      });
      break;
    case SAVE_SUCCESS:
      newState.saving = false;
      newState.nonprofit.asks = newState.nonprofit.asks.map(a => {
        if (a.id === action.payload) {
          a.saved = !a.saved;
          a.saving = false;
        }
        return a;
      });
      break;
    case SAVE_FAILURE:
      newState.saving = false;
      newState.nonprofit.asks = newState.nonprofit.asks.map(a => {
        if (a.id === action.payload) {
          a.saving = false;
        }
        return a;
      });
      break;
    case CATS_LOADED:
      newState.categories = action.payload;
      break;
    case USERS_LOADED:
      newState.users = action.payload;
      break;
    case DELETE_START:
      newState.loading = true;
      break;
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      newState.loading = false;
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/nonprofits/reducer.js